import { logStatsigEvent } from 'atoms/AbTesting/statsigClient';

/**
 * Tracks the click event of a menu link on Statsig
 * @returns void
 */

const menuLinkClickStatsigTrack = (trackingSlug: string): void => {
  if (trackingSlug) {
    logStatsigEvent(`menu_link_${trackingSlug}_click`, 1);
  }
};

export default menuLinkClickStatsigTrack;
